import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=72cb0b99"
import script from "./Index.js?vue&type=script&lang=js&external"
export * from "./Index.js?vue&type=script&lang=js&external"
import style0 from "./Index.vue?vue&type=style&index=0&id=72cb0b99&prod&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=72cb0b99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports